export const FEATURE_HIDE_SHOW_STATUS_COLUMN_04_2025 = "hide-status-featured-categories"
export const FEATURE_PRODUCT_FROM_AI_04_2025 = "data-products-from-ai-04-2025"
export const FEATURE_USE_EMENU_IN_KVWEB = "data-use-emenu-weborder"
export const FEATURE_USE_PRIVATE_DESCRIPTION = "merchant-congtichhop";
